import React, { useContext, useRef, useState, useEffect } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import { useTransitionSafeRef } from "./hooks/useTransitionSafeRef";
import { EmptyMessage } from "./generics/EmptyMessage/EmptyMessage";
import { Select } from "./generics/Select/Select";
import { Header, Heading } from "./styles/Content";

import { ErrorMessage } from "./ErrorMessage";
import { Portal } from "./Portal";
import { useSelect } from "./hooks/useSelect";
import * as css from "./styles/Portals";
import { PortalSortMethods } from "./state/utils/sort";
import { withSuspenseCache } from "./utils/withSuspenseCache";
import { PortalContext } from "./state";

export const Portals: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { state, dispatch } = useContext(PortalContext);
  const portals = withSuspenseCache(state.portals);
  const [label, selectOptions, onValueChanged] = useSelect(
    state.sortedBy,
    dispatch
  );

  const errorKey = `${
    Array.isArray(state.portals) ? state.portals.length >= 0 : "error"
  }`;

  const contentKey = `portals-${state.sortedBy}`;

  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <div  className={css.portalsCls}>
      <Header ref={containerRef}>
        <Heading>Fagportaler</Heading>

        <Select<PortalSortMethods>
          label={`Sortér: ${label}`}
          value={state.sortedBy}
          options={selectOptions}
          containerRef={containerRef}
          onValueChanged={onValueChanged}
          offsetTopPx={4}
        />
      </Header>

      <TransitionGroup component={null}>
        <CSSTransition
          key={errorKey}
          classNames={css.transitionCls}
          timeout={css.ERROR_TRANSITION_DURATION_MS}
          nodeRef={contentRef}
        >
          <>
            {!portals && <ErrorMessage ref={contentRef} />}
            {portals?.length === 0 && (
              <EmptyMessage ref={contentRef} message="Der er ingen tilgængelige fagportaler" />
            )}
            {portals && portals.length > 0 && (
              <TransitionGroup component={null}>
                <CSSTransition
                  key={`list.${state.sortedBy}`}
                  classNames={css.listCls}
                  timeout={{
                    enter: css.LIST_TRANSITION_DURATION,
                    exit: 0,
                  }}
                  nodeRef={contentRef}
                >
                  {/** @ts-expect-error We do not care about the element type */}
                  <ul className={css.listCls} ref={contentRef}>
                    {portals.map((it) => (
                      <Portal key={it.licenseKey} portal={it} />
                    ))}
                  </ul>
                </CSSTransition>
              </TransitionGroup>
            )}
          </>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};
